var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAdd = function SvgAdd(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M499.9 999c-66.7 0-121.2-54.6-121.2-121.3V621.2H122.3C55.5 621.2 1 566.8 1 499.9c0-66.7 54.5-121.2 121.3-121.2h256.5V122.3C378.8 55.5 433.2 1 499.9 1c66.8 0 121.3 54.5 121.3 121.3v256.5h256.5c66.7 0 121.3 54.5 121.3 121.2 0 66.8-54.6 121.3-121.3 121.3H621.2v256.5c0 66.6-54.4 121.2-121.3 121.2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAdd);
export default ForwardRef;